import "./App.css";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Nav from "./components/NavBar";
import Hero from "./components/Hero";
import About from "./components/About";
import Education from "./components/Education";
import Skills from "./components/Skills";
import Experience from "./components/Experience";
import Projects from "./components/Projects";
import Contact from "./components/Contact";
import Footer from "./components/Footer";
import LearningPage from "./components/LearningPage";
import FrontEndTopicPage from "./components/FrontEndTopicPage";
import BackEndTopicPage from "./components/BackEndTopicPage";
import TopicPage from "./components/TopicPage";
import Learnings from "./components/Learnings";
import LearningDetailPage from "./components/LearningDetailPage";
import Resources from "./components/Resources";
import t from "./translations";

function App() {
  const color = "purple";

  return (
    <Router>
      <Nav color={color} />
      <Routes>
        <Route
          path="/"
          element={
            <>
              <Hero color={color} />
              <About color={color} />
              <Education color={color} />
              <Skills color={color} />
              <Experience color={color} />
              <Projects color={color} />
              <Contact color={color} />
            </>
          }
        />
        <Route
          path="/learning"
          element={<LearningPage color={color} />}
        />
        <Route
          path="/frontEndLearning/:slug"
          element={<FrontEndTopicPage color={color} />}
        />
        <Route
          path="/backEndLearning/:slug"
          element={<BackEndTopicPage color={color} />}
        />
        <Route
          path="/testingLearning/:slug"
          element={
            <TopicPage
              color={color}
              topics={t.testingTopics}
              strings={t.testingTopic}
              backPath="/learning"
              tabIndex={2}
            />
          }
        />
        <Route
          path="/mobileLearning/:slug"
          element={
            <TopicPage
              color={color}
              topics={t.mobileTopics}
              strings={t.mobileTopic}
              backPath="/learning"
              tabIndex={3}
            />
          }
        />
        <Route
          path="/designLearning/:slug"
          element={
            <TopicPage
              color={color}
              topics={t.designTopics}
              strings={t.designTopic}
              backPath="/learning"
              tabIndex={4}
            />
          }
        />
        <Route path="/learnings" element={<Learnings />} />
        <Route
          path="/learnings/:slug"
          element={<LearningDetailPage color={color} />}
        />
        <Route path="/resources" element={<Resources />} />
      </Routes>
      <Footer color={color} />
    </Router>
  );
}

export default App;
